export function Overview() {
  return (
    <div className="flex flex-col w-full px-4 sm:px-6 md:px-8 lg:w-2/3 lg:mx-auto text-center">
      {/* Welcome Section */}
      <div className="space-y-4 sm:space-y-6">
        <h1 className="mt-4 sm:mt-6 leading-tight text-primary-900 text-xl sm:text-2xl md:text-3xl font-bold">
          Welcome to College Avenue
        </h1>
        
        <div className="text-sm sm:text-base md:text-lg">
          <p className="mb-4 sm:mb-6">
            Your guide to navigating the <span className="text-primary-700 font-bold">college admissions journey with confidence.</span>
          </p>
          <div className="mx-2 sm:mx-4 p-1 border-primary-900 border-t-2"></div>
          
          <p className="mt-6 sm:mt-8 px-2 sm:px-0">
            The admissions process can be complex, with <span className="text-primary-700 font-bold">limited seats and competitive cutoffs.</span> Understanding past trends helps students set realistic expectations and prepare effectively.
          </p>
          
          <p className="mt-6 sm:mt-8 px-2 sm:px-0">
            At <span className="text-primary-700 font-semibold">College Avenue</span> we bring together <span className="text-primary-700 font-semibold">essential college admission data</span> in one place, helping students stay informed throughout the process.
          </p>
          
          <p className="mt-6 sm:mt-8 px-2 sm:px-0">
            Our platform is not just about data; it's about empowering students with informative resources they need to make well-informed decisions about their academic future.
          </p>
        </div>

        {/* What We Offer Section */}
        <div className="mt-8 sm:mt-12">
          <h1 className="mt-4 sm:mt-6 leading-tight text-primary-900 text-xl sm:text-2xl md:text-3xl font-bold">
            What We Offer
          </h1>
          <div className="mx-2 sm:mx-4 p-1 border-primary-900 border-t-2"></div>
          
          <div className="text-left mt-4 sm:mt-6 mb-6 sm:mb-8 space-y-3 sm:space-y-4 px-2 sm:px-0">
            <p className="text-sm sm:text-base">
              <span className="text-primary-700 font-semibold">✅ Important Dates</span> - Track <span className="text-primary-700 font-semibold">exam schedules & CAP rounds</span> to plan ahead
            </p>
            <p className="text-sm sm:text-base">
              <span className="text-primary-700 font-semibold">✅ Key Notices</span> - Find all official announcements <span className="text-primary-700 font-semibold">in one place</span>
            </p>
            <p className="text-sm sm:text-base">
              <span className="text-primary-700 font-semibold">✅ Seat Availability</span> - Stay updated on <span className="text-primary-700 font-semibold">vacancies</span> as colleges release their lists.
            </p>
            <p className="text-sm sm:text-base">
              <span className="text-primary-700 font-semibold">✅ Cutoff Information</span> - Refer to <span className="text-primary-700 font-semibold">previous years' cutoffs</span> to understand trends.
            </p>
          </div>
        </div>
      </div>

      {/* Mission, Vision, Values Section */}
      <div className="w-full mt-8 sm:mt-12">
        <div className="flex flex-col sm:flex-row sm:flex-wrap lg:flex-nowrap gap-4 sm:gap-6">
          {/* Our Mission */}
          <div className="flex flex-col w-full sm:w-[calc(50%-0.75rem)] lg:w-1/3 border border-primary-600 items-center text-center justify-center p-4 sm:p-6">
            <div className="mt-2 sm:mt-4">
              <i className="fas fa-bullseye text-red-700 text-3xl sm:text-4xl"></i>
            </div>
            <div className="mt-4 sm:mt-6 text-xl sm:text-2xl text-primary-900 font-semibold">
              Our Mission
            </div>
            <div className="mt-3 sm:mt-4 text-sm sm:text-base md:text-lg font-normal">
              To empower students with reliable information and tools to make informed decisions and secure admission to the best-fit colleges for their undergraduate studies.
            </div>
          </div>

          {/* Our Vision */}
          <div className="flex flex-col w-full sm:w-[calc(50%-0.75rem)] lg:w-1/3 border border-primary-600 items-center text-center justify-center p-4 sm:p-6">
            <div className="mt-2 sm:mt-4">
              <i className="fas fa-binoculars text-blue-800 text-3xl sm:text-4xl"></i>
            </div>
            <div className="mt-4 sm:mt-6 text-xl sm:text-2xl text-primary-900 font-semibold">
              Our Vision
            </div>
            <div className="mt-3 sm:mt-4 text-sm sm:text-base md:text-lg font-normal">
              To be the most trusted source of timely, accurate, and actionable information, helping students navigate the process with clarity and confidence.
            </div>
          </div>

          {/* Our Values */}
          <div className="flex flex-col w-full sm:w-full lg:w-1/3 border border-primary-600 items-center text-center justify-center p-4 sm:p-6">
            <div className="mt-2 sm:mt-4">
              <i className="fas fa-balance-scale text-amber-800 text-3xl sm:text-4xl"></i>
            </div>
            <div className="mt-4 sm:mt-6 text-xl sm:text-2xl text-primary-900 font-semibold">
              Our Values
            </div>
            <div className="mt-3 sm:mt-4 text-sm sm:text-base md:text-lg font-normal">
              We are committed to accuracy, transparency, and timeliness, ensuring that students have the information they need to make informed choices about their future.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

